import Vue from 'vue';

const success = (resolve, response) => {
  resolve(response.data);
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(errors);
};

export default (warehouseId, products) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`/warehouses/${warehouseId}/destroy_products`, { products })
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/destroyProducts.js